import { deleteAssetQuery } from '../mutations';
import makeRequest from '../../../../common/utils/makeRequest';

export default async function deleteAsset(
apiClient,
{ assetId })
{
  const requestParams = {
    mutation: deleteAssetQuery,
    variables: { assetId },
    context: {
      module: 'assets'
    }
  };
  const { data, error } = await makeRequest({ request: apiClient.mutate, requestParams });

  if (!data || !data.deleteAsset || error) {return null;}

  return data.deleteAsset;
}
